import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import exportingModule from "highcharts/modules/exporting";
import exportDataModule from 'highcharts/modules/export-data'
import { singleChartWidth, chartHeight, post2 } from '../../services';
import useWindow from '../../hooks/useWindow'
exportingModule(Highcharts);
exportDataModule(Highcharts);


export const ChatChart = ({ param }) => {
    const [options, setOptions] = useState({})
    const size = useWindow()

    useEffect(() => {
        const { title, subtitle, categories, series, yAxis = { title: { text: '' } } } = param
        const options = {
            chart: {
                type: 'spline',
                width: singleChartWidth(size.width)-70,
                height: chartHeight(size.height)
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: true,
                        align: 'left',
                        menuItems: ["downloadPNG", "downloadPDF", "downloadCSV", "separator",
                            {   
                                text: 'Send Email', 
                                onclick: function() {
                                    const csv = this.getCSV()
                                    const html = this.getSVG()
                                    const title = this.getFilename()
                                    post2('user/export_file', { csv, html, title })
                                } 
                            }
                        ]
                    }
                }
            },
            title: { text: title },
            subtitle: { text: subtitle, align: 'right' },
            xAxis: {
                title: { text: '' },
                categories,
                tickInterval: Math.round(categories.length/8)
            },
            yAxis,
            plotOptions: { 
                spline: { marker: { enabled: false } },
                column: { stacking: 'normal', dataLabels: { enabled: false } } 
            },
            series
        }
        setOptions(options)
        console.log(options)
    }, [param, size])

    return <div className='row-center'>
        <HighchartsReact highcharts={Highcharts} options={options} />
    </div>

}